/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'collection-dropdown';
const prefix = `${moduleName}.${componentName}`;

export const searchInputPlaceholder = `${prefix}.searchInputPlaceholder`;
export const noValidEntriesLabel = `${prefix}.noValidEntriesLabel`;
export const createButtonLabel = `${prefix}.createButtonLabel`;

export const ENGLISH = {
    [searchInputPlaceholder]: 'Search',
    [noValidEntriesLabel]: '-- no valid entries --',
    [createButtonLabel]: 'Create',
};
